import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  NavigateNext,
  RemoveRedEyeOutlined,
  SearchOutlined,
} from "@mui/icons-material";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { dateTimeToView } from "../../../utils/date.utils";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { debouncedApiCall } from "../../../utils/app.utils";
import ModalFormConsultation from "./components/ModalFormConsultation";
import { advisorTypeApi } from "../../../api/advisor-type/advisor-type.api";

type Props = {};

const ManageConsultationTypes: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState<any[]>([]);
  const [singleData, setSingleData] = useState<any>({});
  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [isShowModalUpdate, setIsShowModalUpdate] = useState<boolean>(false);

  const getAdvisorType = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };

    if (search) query = { ...query, search: search };

    const res = await advisorTypeApi.getAllAdvisorType(query);

    const data = res.data;
    if (data.status < 300) {
      setData(data.data.items);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  const handleUpdateStatus = async (id: number, status: string) => {
    await advisorTypeApi
      .updateAdvisorType(id, {
        status: status,
      })
      .then((res) => {
        if (res.status < 300) {
          dispatch(unsetLoading());
          alertSuccess(
            "แก้ไขสถานะประเภทคำปรึกษา",
            "แก้ไขสถานะประเภทคำปรึกษา เรียบร้อยแล้ว",
            undefined,
            () => {
              dispatch(unsetLoading());
              getAdvisorType();
            }
          );
        }
      })
      .catch(() => {
        alertError("แก้ไขสถานะประเภทคำปรึกษา ไม่สำเร็จ");
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  };

  const headCells = [
    {
      id: "advisor_type_name",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่อประเภท",
    },
    {
      id: "status",
      disablePadding: false,
      width: 5,
      sortable: false,
      align: "center",
      label: "สถานะ",
    },
    {
      id: "user_updated",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "ผู้สร้าง/ปรับปรุงล่าสุด",
    },
    {
      id: "modified_date",
      disablePadding: false,
      align: "center",
      width: 50,
      label: "วันที่สร้าง/ปรับปรุงล่าสุด",
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_advisor_type,
      advisor_type_name,
      status,
      first_name_c,
      last_name_c,
      modified_date,
    } = objData;

    const objRenderData = {
      key: id_advisor_type,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: advisor_type_name,
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div className="w-full flex justify-center ">
              <SwitchCustom
                checked={status === "active" ? true : false}
                onChange={(value: boolean) => {
                  handleUpdateStatus(
                    id_advisor_type,
                    value ? "active" : "inactive"
                  );
                }}
              />
            </div>
          ),
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: <>{first_name_c + " " + last_name_c}</>,
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_date ? dateTimeToView(modified_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <RemoveRedEyeOutlined
              onClick={() => {
                setIsShowModalUpdate(true);
                setSingleData(objData);
              }}
              style={{
                cursor: "pointer",
              }}
            />
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  useEffect(() => {
    getAdvisorType();
  }, [page, pageLimit, sortBy, sortType, search]);

  return (
    <div>
      <ModalFormConsultation
        setIsOpenModal={(isOpen: boolean) => setIsShowModal(isOpen)}
        isOpenModal={isShowModal}
        action={"create"}
        onFetch={() => {
          getAdvisorType();
        }}
      />

      <ModalFormConsultation
        setIsOpenModal={(isOpen: boolean) => setIsShowModalUpdate(isOpen)}
        isOpenModal={isShowModalUpdate}
        action={"update"}
        data={singleData}
        onFetch={() => {
          getAdvisorType();
        }}
      />

      <ContentHeading
        title={"จัดการประเภทคำปรึกษา"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อประเภท"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article
          className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <ButtonPrimary
            onClick={() => {
              setIsShowModal(true);
            }}
            mode="add"
            buttonName={"เพิ่มประเภทคำปรึกษา"}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default ManageConsultationTypes;
